import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

export const startAuth = async (data) => {
  const res = await axios.post(`${API}/auth/start`, data);
  return res.data;
};

export const verifyAuth = async (data) => {
  const res = await axios.post(`${API}/auth/verify`, data);
  return res.data;
};

export const getMe = async () => {
  const res = await axios.get(`${API}/genesis/me`);
  return res.data;
};

export const logoutAuth = async () => {
  const res = await axios.post(`${API}/auth/logout`);
  return res.data;
};

export const resubscribeAuth = async () => {
  const res = await axios.post(`${API}/auth/resubscribe`);
  return res.data;
};

export const applyValidator = async (data) => {
  const res = await axios.post(`${API}/validators/apply`, data);
  return res.data;
};

export const requestPilot = async (data) => {
  const res = await axios.post(`${API}/enterprise/pilot`, data);
  return res.data;
};

export const getStats = async () => {
  const res = await axios.get(`${API}/stats`);
  return res.data;
};

export const getLeaderboard = async () => {
  const res = await axios.get(`${API}/leaderboard`);
  return res.data;
};

export const getInvite = async (code) => {
  const res = await axios.get(`${API}/invite/${encodeURIComponent(code)}`);
  return res.data;
};
